import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventsPage } from './events';
import {ComponentsModule} from "../../components/components.module";
import {DummyDataProvider} from "../../providers/dummy-data/dummy-data";
import {ContentLoaderModule} from "@netbasal/ngx-content-loader";

@NgModule({
  declarations: [
    EventsPage,
  ],
  imports: [
    IonicPageModule.forChild(EventsPage),
    ComponentsModule,
    ContentLoaderModule
  ],
  providers:[
    DummyDataProvider
  ]
})
export class EventsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/events/events.module.ts